<template>
  <RevDrawer
    :has-padding="false"
    :name="MODAL_NAMES.LAPTOP_PROCESSOR"
    :title="i18n(translations.title)"
  >
    <template #body>
      <LaptopProcessorModalBody />
    </template>
  </RevDrawer>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'

import { MODAL_NAMES } from '~/scopes/product-core/constants'

import translations from './LaptopProcessorModal.translations'
import LaptopProcessorModalBody from './components/LaptopProcessorModalBody/LaptopProcessorModalBody.vue'

const i18n = useI18n()
</script>
